import { render, staticRenderFns } from "./chooseStyle.vue?vue&type=template&id=2baee631&scoped=true&"
import script from "./chooseStyle.vue?vue&type=script&lang=ts&"
export * from "./chooseStyle.vue?vue&type=script&lang=ts&"
import style0 from "./chooseStyle.vue?vue&type=style&index=0&lang=less&"
import style1 from "./chooseStyle.vue?vue&type=style&index=1&id=2baee631&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baee631",
  null
  
)

export default component.exports